<template>
  <div>
    <BlockUI v-if="busy">
        <div class="loader"></div>
    </BlockUI>
    <base-header type="gradient-blue" class="pb-6 pb-8 pt-5 pt-md-8">
        <div class="row mb-2">
            <div class="col-12 col-md-12 col-lg-8">
                <h1 class="text-white pt-3 px-3">รายงาน cod ค่าคอมมิชชั่น</h1>
                <p class="text-white pb-0 px-3">สรุปยอดรวมค่าคอมมิชชั่น ของที่ shippop จ่ายเงินไปให้ shop และ ยังไม่จ่ายเงิน</p>
            </div>
            <div class="col-12 col-md-12 col-lg-4 align-self-center">
              <div class="d-flex justify-content-end align-items-center">
                <b-button variant="primary" @click="ExportSumGroupBy">
                  Export ข้อมูลราคา COD ทั้งหมด
                </b-button>
              </div>
            </div>
        </div>
    </base-header>
    <div class="container-fluid mt--4 mb-5">
      <div class="row">
          <div class="col">
            <div id="billtab-bar" class="mt--5">
              <b-tabs v-model="tabIndex" content-class="" class="billtabs">
                <b-tab title="cod รายชิ้น" class="billtab" @click="selectTab('order_cod')" active>
                  <div class="card-header">
                      <div class="row px-2 py-1">
                        <div class="col-12 col-md-12 col-lg-12 col-xl-12">
                          <div class="form-group mb-0">
                              <div class="row">
                                  <div class="col-12 col-md-12 col-lg-4">
                                    <div class="form-group mb-0">
                                      <label class="text">วันที่สร้างบิล (วันเริ่มต้น - วันสุดท้าย)</label><label class="mb-0 p-custom text-muted"></label>
                                      <div class="row">
                                          <div class="col-6 col-md-4 col-lg-6 content--">
                                            <input type="date" v-model="filters.date_start" @change="disabledFinding" class="form-control" @input="$v.filters.date_start.$touch" :class="{ 'is-invalid': $v.filters.date_start.$dirty && ($v.filters.date_start.$invalid)}" />
                                          </div>
                                          <div class="col-6 col-md-4 col-lg-6 mb-3">
                                            <input type="date" v-model="filters.date_end" @change="disabledFinding" class="form-control" @input="$v.filters.date_end.$touch" :class="{ 'is-invalid': $v.filters.date_end.$dirty && ($v.filters.date_end.$invalid)}" />
                                          </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-12 col-md-12 col-lg-2">
                                      <b-form-group id="input-group-1" label="สถานะการจ่ายเงิน" label-for="input-1" class="mb-3">
                                          <b-form-select v-model="filters.status" :options="optionsStatus"></b-form-select>
                                      </b-form-group>
                                  </div>                        
                                  <div class="col-12 col-md-12 col-lg-2 align-self-end mb-3">
                                      <b-button class="btn btn-info" :disabled="disabledFinding" block @click="findFilterOrderCod()">
                                          <i class="fa fa-search"></i>
                                      </b-button>
                                  </div>
                                  <div class="col-12 col-md-12 col-lg-4 align-self-end mb-3">
                                      <b-button class="btn btn-info" :disabled="disabledFinding" block @click="ExportFilterOrderCod()">
                                          Export
                                      </b-button>
                                  </div>
                              </div>
                          </div>
                        </div>
                      </div>
                  </div>
                  <PaidCodTable  :items="items" :search="search" @onRowSelected="onRowSelected" @selectAllRows="selectAllRows" />
                </b-tab>
              </b-tabs>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { required } from "vuelidate/lib/validators"
import PaidCodTable from '@/components/Table/PaidCodTable.vue'
export default {
  components: {
    PaidCodTable
  },
  data() {
    return {
      busy: false,
      tabIndex: 0,
      search: {
        page: 1,
        perPage: 50,
      },
      items: [],
      filters: {
        date_start: '',
        date_end: '',
        status: null,
        excel_action: false,
        excel_sum_groupby: false,
      },
      optionsStatus: [
          { value: null, text: 'ทั้งหมด' },
          { value: 'BOOKING', text: 'รอโอนเงิน' },
          { value: 'TRANSFERRED', text: 'โอนเงินแล้ว' },              
      ]
    }
  },
  validations: {
        filters: {
            date_start: {
                required
            },
            date_end: {
                required,
                validEndDate(value) {
                    return moment(value).valueOf() < moment().add(-1, 'day').endOf('day').valueOf()
                }
            },
        },
  },
  computed: {
    disabledFinding() {
      if(!this.filters.date_start || !this.filters.date_end) {
        return true
      }
      return false
    }
  },
  methods: {
    ExportSumGroupBy() {
      this.filters.excel_sum_groupby = true
      const headers = {
        headers: {
          token: localStorage.getItem('access_token')
        }
      }
      this.$http.post(this.$API_URL + '/shippop/billing/cod/exportsum', this.filters, headers).then((res) => {
        if(res.data.status) {
          const linkdownload = res.data.data.download_link
          window.open(linkdownload, '_blank');
        }
        this.items = res.data.data
      }).finally(() => {
        this.filters.excel_sum_groupby = false
      })
    },
    ExportFilterOrderCod() {
      this.filters.excel_action = true
      const headers = {
        headers: {
          token: localStorage.getItem('access_token')
        }
      }
      this.$http.post(this.$API_URL + '/shippop/billing/cod', this.filters, headers).then((res) => {
        if(res.data.data.download_link) {
            window.open(res.data.data.download_link, '_blank');
        }
      }).finally(() => {
        this.filters.excel_action = false
      })
    },
    async findFilterOrderCod() {
      const headers = {
        headers: {
          token: localStorage.getItem('access_token')
        }
      }
      this.$http.post(this.$API_URL + '/shippop/billing/cod', this.filters, headers).then((res) => {
        this.items = res.data.data
      })
    }
  }
}
</script>